export default function StatsStrip() {
  const items = [
    { title: "Prevention-first", desc: "Visible deterrence and calm control." },
    { title: "Clear reporting", desc: "Accurate logs and incident notes." },
    { title: "Reliable cover", desc: "Flexible staffing for venues & sites." },
  ];

  return (
    <section className="bg-ink text-white">
      <div className="mx-auto max-w-6xl px-4 py-12">
        <div className="grid gap-6 md:grid-cols-3">
          {items.map((x) => (
            <div
              key={x.title}
              className="rounded-3xl border border-white/10 bg-white/5 p-6"
            >
              <div className="text-lg font-semibold">
                {x.title} <span className="text-redAccent">●</span>
              </div>
              <div className="mt-2 text-sm text-white/75">{x.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
